  const initState = {
    commonLoading:false
  };
  const CommonReducer = (state = initState, action) => {
    switch (action.type) {
      case "SET_COMMON_LOADING":
        return {
          ...state,
          commonLoading: action.payload.data,
        };
      default:
        return { ...state };
    }
  }

  export default CommonReducer;